export default [
  {
    path: '/drop-off',
    name: 'drop-off',
    component: () => import('@/views/pages/partner/drop-off/List.vue'),
    meta: {
      name: 'drop-off',
      resource: 'Partner - Drop Off',
      action: 'manage',
    },
  },
]
